import React from 'react'
import classNames from 'classnames'

import type { SnowflakeAreaViewProps } from './snowflake-area.types'
import './snowflake-area.styles.scss'

export const SnowflakeAreaView: React.FC<SnowflakeAreaViewProps> = ({
  snowflakes,
  getSnowflakeClassName,
  className,
  isVisible,
  isFadingOut,
  onAutoHideComplete,
}) => {
  if (!isVisible) {
    return null
  }

  return (
    <div
      className={classNames('snowflake-area', { 'snowflake-area--fading-out': isFadingOut }, className)}
      onAnimationEnd={e => {
        if (e.animationName === 'fadeOut' && isFadingOut) {
          onAutoHideComplete()
        }
      }}
    >
      {snowflakes.map(snowflake => (
        <div key={snowflake.id} className={getSnowflakeClassName(snowflake)}>
          ❄️
        </div>
      ))}
    </div>
  )
}
